import React from "react";
import { Tooltip } from "antd";
import FeatherIcon from "feather-icons-react";
import translate from "../../../../shared/utils/translations";
import {
  copyToClipboard,
  makeReadable,
} from "../../../../shared/utils/helpers";

const MainInfos = ({
  mainData,
  keepaData,
  additionalData,
  targetOffersData,
  imageUrl,
  noImg,
}) => {
  const trendDirection = (value90, value30) => {
    const drop90 = parseFloat(value90) / 90;
    const drop30 = parseFloat(value30) / 30;
    if (drop90 > drop30) {
      return "down";
    } else if (drop90 < drop30) {
      return "up";
    } else {
      return "up";
    }
  };
  return (
    <>
      <div className="product__main_info">
        <div className="leftt__box">
          <img src={imageUrl || noImg}></img>
        </div>
        <div className="right__box">
          <div className="pr_title">
            <h4>{additionalData?.title}</h4>
            <Tooltip title={translate("Copy")} placement="top">
              <button
                className="icconc__btn"
                onClick={() => copyToClipboard(additionalData?.title)}
              >
                <FeatherIcon icon={"copy"} />
              </button>
            </Tooltip>
          </div>
          <div className="btmm_infos">
            <div className="catehgory__area">
              {makeReadable(targetOffersData?.salesRankCategory)}
            </div>
            {/* asagidaki data yok extensionda */}
            {/* <div className="reviws__area">
              <div className="r_te">
                <FeatherIcon icon={"star"} />{" "}
                <div className="r_te_Value">4.4</div>
              </div>
              <span>12,242 ratings</span>
            </div> */}
          </div>

          <div className="fees__area">
            <div className="fees_item">
              <h4>{translate("Sales Rank")}</h4>
              <span>{targetOffersData?.salesRank}</span>
            </div>
            <div className="fees_item">
              <h4>{translate("BSR Drops (30/90/180)")}</h4>
              <span>
                {keepaData?.BSR30 +
                  "/" +
                  keepaData?.BSR90 +
                  "/" +
                  keepaData?.BSR180}
                {trendDirection(keepaData?.BSR90, keepaData?.BSR30) ===
                "down" ? (
                  <Tooltip title={"Downward Trend"} placement="top">
                    <img
                      className="trend__up"
                      src="/assets/img/icons8-chart-arrow-descent-64.png"
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={"Upward Trend"} placement="top">
                    <img
                      className="trend__up"
                      src="/assets/img/icons8-chart-arrow-rise-64.png"
                    />
                  </Tooltip>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainInfos;
